import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import PageNotFound from "../../../shared/presentations/PageNotFound";
import TimeOffManagementPage from "./pages/TimeOffManagementPage";

export const TimeOffManagementRoutes = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={match.path + "/"} exact={true}>
        <TimeOffManagementPage />
      </Route>
      <Route>
        <PageNotFound />
      </Route>
    </Switch>
  );
};
